import { Outlet, useNavigate, useLocation, Link } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { LayoutDashboard, Factory, Store, ClipboardList, CreditCard, Wallet, Undo2, ScrollText, BookText, Package, Plug, LogOut, Menu, X, Repeat, Mail } from "lucide-react";

const NAV = [
  { to: "/admin", icon: LayoutDashboard, label: "Overview", end: true },
  { to: "/admin/manufacturers", icon: Factory, label: "Manufacturers" },
  { to: "/admin/retailers", icon: Store, label: "Retailers" },
  { to: "/admin/products", icon: Package, label: "Products" },
  { to: "/admin/orders", icon: ClipboardList, label: "Orders" },
  { to: "/admin/payments", icon: CreditCard, label: "Payments" },
  { to: "/admin/subscriptions", icon: Repeat, label: "Subscriptions" },
  { to: "/admin/sales", icon: Mail, label: "Sales Requests" },
  { to: "/admin/settlements", icon: Wallet, label: "Settlements" },
  { to: "/admin/returns", icon: Undo2, label: "Returns" },
  { to: "/admin/ledger", icon: BookText, label: "Financial Ledger" },
  { to: "/admin/audit", icon: ScrollText, label: "Audit Logs" },
  { to: "/admin/integrations", icon: Plug, label: "Integrations" },
];

export default function AdminLayout() {
  const nav = useNavigate();
  const loc = useLocation();
  const { logout } = useAuth();
  const [open, setOpen] = useState(false);
  const active = (to, end) => (end ? loc.pathname === to : loc.pathname.startsWith(to));

  return (
    <div className="min-h-screen bg-sgrey lg:flex">
      <aside className={cn("fixed inset-y-0 left-0 z-40 w-64 transform overflow-y-auto border-r border-border bg-forest transition-transform lg:static lg:translate-x-0",
        open ? "translate-x-0" : "-translate-x-full")}>
        <div className="flex items-center justify-between p-5">
          <Logo dark />
          <button className="text-white lg:hidden" onClick={() => setOpen(false)}><X className="h-5 w-5" /></button>
        </div>
        <nav className="space-y-1 px-3 pb-20">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} data-testid={`anav-${n.label.toLowerCase().replace(/ /g, "-")}`} onClick={() => setOpen(false)}
              className={cn("flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors",
                active(n.to, n.end) ? "bg-white text-forest" : "text-psage hover:bg-white/10")}>
              <n.icon className="h-4 w-4" /> {n.label}
            </Link>
          ))}
          <Button data-testid="admin-logout" variant="ghost" className="mt-2 w-full justify-start text-psage hover:bg-white/10" onClick={() => { logout(); nav("/"); }}>
            <LogOut className="mr-3 h-4 w-4" /> Log out
          </Button>
        </nav>
      </aside>
      {open && <div className="fixed inset-0 z-30 bg-black/40 lg:hidden" onClick={() => setOpen(false)} />}
      <div className="flex-1">
        <header className="flex items-center justify-between border-b border-border bg-card px-4 py-3 lg:hidden">
          <button onClick={() => setOpen(true)}><Menu className="h-5 w-5 text-forest" /></button>
          <Logo className="scale-90" /><div className="w-5" />
        </header>
        <main className="p-5 lg:p-8"><Outlet /></main>
      </div>
    </div>
  );
}
